// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'lib-flexible/flexible.js'
import "./css/__common.css"
import "./css/__edit.css"
import "./css/__iconfunt.css"
import 'swiper/dist/css/swiper.css';
import store from './store/store'
import Toast from './base/toast.js';
Vue.use(Toast);
import VueAwesomeSwiper from 'vue-awesome-swiper'
import back from "./js/back";
import {Alert, Confirm,  Loading} from 'wc-messagebox'
import 'wc-messagebox/style.css'

let options = {};
Vue.use(Alert, options);
Vue.use(Confirm, options);
Vue.use(Toast, options);
Vue.use(Loading);

Vue.use(VueAwesomeSwiper);
Vue.config.productionTip = false;
import axios from 'axios';

Vue.prototype.axios = axios;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  axios,
  store,
  back,
  components: {App},
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js